import { IconName } from '@travelata-libs/ui-kit';
import { ConfirmationType } from '../model/types';

export const CONFIRMATION_TYPE_ICONS: Record<ConfirmationType, `${IconName}`> = {
  [ConfirmationType.Quick]: IconName.BoltFilled,
  [ConfirmationType.Long]: IconName.ClockFilled,
  [ConfirmationType.Cancel]: IconName.Wrong,
};
